module.exports = __webpack_public_path__ + "img/RW.b5d18d77.svg";